// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2AZAY","rightAdornment":"Header_rightAdornment__23bPn"};